// extracted by mini-css-extract-plugin
export default {"closeButton":"BotGraph_closeButton__1yxYF"};